/**
 * Whether this page is running inside a frame on someone else's page.
 *
 * The CloudFront headers in template.yaml decide who may frame the site
 * (X-Frame-Options: DENY today). Framing may be opened so the payment
 * provider's domain review can preview the public landing page (task 28).
 * Either way, index.tsx never starts the app inside a frame: a framer sees
 * only the static landing card in public/index.html, whose links open the
 * full window, so the login form and account pages never render in a frame.
 *
 * A cross-origin parent makes reading window.top throw in some browsers;
 * that counts as framed.
 */
export function isFramed(win: Window = window): boolean {
  try {
    return win.self !== win.top;
  } catch {
    return true;
  }
}
